import { render } from "./JFmanual.vue?vue&type=template&id=2f87fd62&scoped=true"
import script from "./JFmanual.vue?vue&type=script&lang=js"
export * from "./JFmanual.vue?vue&type=script&lang=js"

import "./JFmanual.vue?vue&type=style&index=0&id=2f87fd62&lang=scss&scoped=true"
import "./JFmanual.vue?vue&type=style&index=1&id=2f87fd62&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f87fd62"]])

export default __exports__